import { Component } from '@angular/core';
import { GeneralInfoSectionComponent } from './features/vehicle-statement/components/general-info-section/general-info-section';
import { buildStatementForm } from './features/vehicle-statement/services/statement-form.factory';

@Component({
  selector: 'app-debug-layout',
  imports: [GeneralInfoSectionComponent],
  template: `<div class="page-container">
    <app-general-info-section [group]="form.controls.general" [showErrors]="false" />
  </div>`,
})
export class DebugLayoutComponent {
  protected readonly form = buildStatementForm();
}
